import React from 'react'

import { Header } from '../../Typogaphy/Header';

import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';

import { FaUserCircle } from "react-icons/fa";
import { pageRoutes } from '../../../routes/pageRoutes';

export const ProfileForm = ({ handleStepper }) => {
    // Example options arrays
    const genderOptions = [
        { value: '', label: 'Select Gender' },
        { value: 'male', label: 'Male' },
        { value: 'female', label: 'Female' },
    ];

    const civilStatusOptions = [
        { value: '', label: 'Select Civil Status' },
        { value: 'single', label: 'Single' },
        { value: 'married', label: 'Married' },
        { value: 'widowed', label: 'Widowed' },
        { value: 'divorced', label: 'Divorced' }
    ];

    const [formValues, setFormValues] = React.useState({
        firstName: '',
        middleName: '',
        lastName: '',
        gender: '',
        civilStatus: '',
        birthDate: '',
        personalEmail: '',
        phoneNumber: '',
        currentAddress: '',
        permanentAddress: '',
        parents: {
            fatherName: '',
            motherMaidenName: '',
            homeAddress1: '',
            homeAddress2: ''
        },
        emergencyContact: {
            name: '',
            contactNumber: '',
            address: ''
        }
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleParentsChange = (e) => {
        const { name, value } = e.target;
        setFormValues(prev => ({
            ...prev,
            parents: { ...prev.parents, [name]: value }
        }));
    };

    const handleEmergencyContactChange = (e) => {
        const { name, value } = e.target;
        setFormValues(prev => ({
            ...prev,
            emergencyContact: { ...prev.emergencyContact, [name]: value }
        }));
    };

    const handleSave = () => {
        alert(JSON.stringify(formValues, null, 2));
        handleStepper(2);
    };

    return (
        <div className='flex-1 overflow-y-auto p-4'>

            <div className='w-full items-center justify-between flex flex-row gap-2 my-3 max-sm:flex-col'>
                <img
                    className='w-[280px] h-[50px]'
                    src="https://www.sixelevenbpo.com/wp-content/uploads/2020/05/six-eleven-center-logo.png"
                    alt=''
                />
                <div className='items-center flex flex-col my-3'>
                    <Header text={"Personal Information"} style={"text-xl font-lexend"} />
                    <span className='text-green-600 font-light font-lexend text-sm'>Applicant's Information</span>
                </div>
            </div>

            <div className='w-full flex flex-col gap-3 mb-5'>

                <Divider><Chip label="Basic Information" color="success" variant="outlined" /></Divider>

                <div className='w-full grid grid-cols-3 max-md:grid-cols-1 max-lg:grid-cols-2 gap-2'>

                    <FormControl fullWidth>
                        <span className='mb-3 font-normal text-xs  font-lexend'>First Name</span>
                        <TextField
                            id="first-name"
                            name="firstName"
                            size="small"
                            placeholder="type here..."
                            value={formValues.firstName}
                            onChange={handleChange}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <span className='mb-3 font-normal text-xs  font-lexend'>Middle Name</span>
                        <TextField
                            id="middle-name"
                            name="middleName"
                            size="small"
                            placeholder="type here..."
                            value={formValues.middleName}
                            onChange={handleChange}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <span className='mb-3 font-normal text-xs font-lexend'>Last Name</span>
                        <TextField
                            id="last-name"
                            name="lastName"
                            size="small"
                            placeholder="type here..."
                            value={formValues.lastName}
                            onChange={handleChange}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <span className='mb-3 font-normal text-xs font-lexend'>Gender</span>
                        <TextField
                            id="gender-select"
                            name="gender"
                            size="small"
                            select
                            value={formValues.gender}
                            onChange={handleChange}
                            SelectProps={{
                                native: true,
                            }}
                        >
                            {genderOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </TextField>
                    </FormControl>

                    <FormControl fullWidth>
                        <span className='mb-3 font-normal text-xs font-lexend'>Civil Status</span>
                        <TextField
                            id="civil-status-select"
                            name="civilStatus"
                            size="small"
                            select
                            value={formValues.civilStatus}
                            onChange={handleChange}
                            SelectProps={{
                                native: true,
                            }}
                        >
                            {civilStatusOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </TextField>
                    </FormControl>

                    <FormControl fullWidth>
                        <span className='mb-3 font-normal text-xs font-lexend'>Birth Date</span>
                        <TextField
                            id="birth-date"
                            name="birthDate"
                            size="small"
                            type='date'
                            value={formValues.birthDate}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </FormControl>
                </div>

                <Divider><Chip label="Contact Information" color="success" variant="outlined" /></Divider>

                <div className='w-full grid grid-cols-2 max-md:grid-cols-1 max-lg:grid-cols-2 gap-2'>

                    <FormControl fullWidth>
                        <span className='mb-3 font-normal text-xs font-lexend'>Personal Email</span>
                        <TextField
                            id="personal-email"
                            name="personalEmail"
                            size="small"
                            type='email'
                            placeholder="type here..."
                            value={formValues.personalEmail}
                            onChange={handleChange}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <span className='mb-3 font-normal text-xs font-lexend'>Phone Number</span>
                        <TextField
                            id="phone-number"
                            name="phoneNumber"
                            size="small"
                            placeholder="type here..."
                            value={formValues.phoneNumber}
                            onChange={handleChange}
                        />
                    </FormControl>
                </div>

                <Divider><Chip label="Applicant Address" color="success" variant="outlined" /></Divider>

                <FormControl fullWidth>
                    <span className='mb-3 font-normal text-xs font-lexend'>Current Address</span>
                    <TextField
                        id="current-address"
                        name="currentAddress"
                        size="small"
                        placeholder="type here..."
                        value={formValues.currentAddress}
                        onChange={handleChange}
                    />
                </FormControl>

                <FormControl fullWidth>
                    <span className='mb-3 font-normal text-xs font-lexend'>Permanent Address</span>
                    <TextField
                        id="permanent-address"
                        name="permanentAddress"
                        size="small"
                        placeholder="type here..."
                        value={formValues.permanentAddress}
                        onChange={handleChange}
                    />
                </FormControl>

                <Divider className="py-3">
                    <Chip
                        label="Parents Information"
                        color="success"
                        variant="outlined"
                    />
                </Divider>
                <div className="grid grid-cols-2 max-md:grid-cols-1 gap-2">
                    <FormControl fullWidth>
                        <span className="mb-3 font-normal text-xs font-lexend">Father's Name </span>
                        <TextField
                            id="father-name"
                            size="small"
                            type="text"
                            placeholder="type here..."
                            name="fatherName"
                            value={formValues.parents.fatherName}
                            onChange={handleParentsChange}
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <span className="mb-3 font-normal text-xs font-lexend"> Mother's Maiden Name </span>
                        <TextField
                            id="mother-maiden-name"
                            size="small"
                            type="text"
                            placeholder="type here..."
                            name="motherMaidenName"
                            value={formValues.parents.motherMaidenName}
                            onChange={handleParentsChange}
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <span className="mb-3 font-normal text-xs font-lexend"> Home Address </span>
                        <TextField
                            id="home-address-1"
                            size="small"
                            type="text"
                            placeholder="type here..."
                            name="homeAddress1"
                            value={formValues.parents.homeAddress1}
                            onChange={handleParentsChange}
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <span className="mb-3 font-normal text-xs font-lexend"> Home Address </span>
                        <TextField
                            id="home-address-2"
                            size="small"
                            type="text"
                            placeholder="type here..."
                            name="homeAddress2"
                            value={formValues.parents.homeAddress2}
                            onChange={handleParentsChange}
                        />
                    </FormControl>
                </div>

                <Divider className="py-3">
                    <Chip
                        label="Emergency Contact"
                        color="success"
                        variant="outlined"
                    />
                </Divider>

                <div className="w-full grid grid-cols-1 gap-2">

                    <div className="grid grid-cols-2 max-md:grid-cols-1 gap-2">
                        <FormControl fullWidth>
                            <span className="mb-3 font-normal text-xs font-lexend"> Name </span>
                            <TextField
                                id="emergency-name"
                                size="small"
                                type="text"
                                placeholder="type here..."
                                name="name"
                                value={formValues.emergencyContact.name}
                                onChange={handleEmergencyContactChange}
                            />
                        </FormControl>

                        <FormControl fullWidth>
                            <span className="mb-3 font-normal text-xs  font-lexend"> Contact Number </span>
                            <TextField
                                id="emergency-contactNumber"
                                size="small"
                                type="text"
                                placeholder="type here..."
                                name="contactNumber"
                                value={formValues.emergencyContact.contactNumber}
                                onChange={handleEmergencyContactChange}
                            />
                        </FormControl>
                    </div>
                    <FormControl fullWidth>
                        <span className="mb-3 font-normal text-xs font-lexend"> Address </span>
                        <TextField
                            id="emergency-address"
                            size="small"
                            type="text"
                            placeholder="type here..."
                            name="address"
                            value={formValues.emergencyContact.address}
                            onChange={handleEmergencyContactChange}
                        />
                    </FormControl>
                </div>

                <div className='w-full flex flex-end justify-end'>
                    <div onClick={handleSave} className='font-lexend bg-green-600 flex flex-col items-center justify-center rounded py-2 px-3 cursor-pointer text-white font-medium hover:bg-green-800'>
                        <span>Save Personal Information</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
